var BindingCount = {
    MultipleBindingsAvailable: 2,
    NoBindingsAvailable: 0,
    OnlyOneBindingAvailable: 1
};
export { BindingCount };
//# sourceMappingURL=binding_count.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/inversify/es/bindings/binding_count.js
// module id = 1712
// module chunks = 0